"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LockKeyholeIcon, WandSparklesIcon } from "lucide-react";
import { useState } from "react";
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from "../ui/card";
import ZeekMapsIcon from "../ui/icons/ZeekMapsIcon";
import SignUpForm from "./sign-up-form";
import SignUpSuccess from "./sign-up-success";

interface SignUpEmailProps {
	email?: string;
	className?: string;
}

export default function SignUpEmail({ email, className }: SignUpEmailProps) {
	const [loginType, setLoginType] = useState<"magic-link" | "password" | null>(
		null,
	);

	if (email && loginType === "magic-link") {
		return <SignUpSuccess email={email} />;
	}

	if (email && loginType === "password") {
		return <SignUpForm email={email} />;
	}

	return (
		<Card
			className={cn(
				"-space-y-2 bg-transparent border-none shadow-none",
				className,
			)}
		>
			<CardHeader className="items-center justify-center text-center space-y-4">
				<ZeekMapsIcon className="w-16 h-16" />
				<CardTitle className="text-3xl font-extrabold tracking-tighter">
					Sign Up
				</CardTitle>
				<CardDescription>
					Choose your preferred method to sign up with your email
				</CardDescription>
			</CardHeader>
			<CardContent>
				<span className="block text-lg text-center font-bold text-primary bg-primary/10 rounded-full border border-primary/20">
					{email}
				</span>
			</CardContent>
			<CardFooter>
				<div className="w-full flex flex-col space-y-2">
					<Button
						type="submit"
						variant="default"
						className="w-full rounded-full font-bold"
						onClick={() => setLoginType("magic-link")}
					>
						<WandSparklesIcon className="w-4 h-4" />
						Sign Up With Email
					</Button>
					<Button
						type="submit"
						variant="default"
						className="w-full rounded-full font-bold"
						onClick={() => setLoginType("password")}
					>
						<LockKeyholeIcon className="w-4 h-4" />
						Sign Up With Password
					</Button>
				</div>
			</CardFooter>
		</Card>
	);
}
